var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchDomain1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.15 123.15L499.39 123.15L499.39 2.91L140.61 2.91L140.61 123.15L36.85 123.15L36.85 506.18L604.12 506.18L604.12 123.15L603.15 123.15ZM140.61 452.85L89.21 452.85L89.21 176.48L139.64 176.48L139.64 452.85L140.61 452.85ZM484.85 96L484.85 452.85L155.15 452.85L155.15 96L484.85 96ZM549.82 176.48L549.82 452.85L499.39 452.85L499.39 176.48L549.82 176.48ZM484.85 82.42L155.15 82.42L155.15 17.45L484.85 17.45L484.85 82.42ZM51.39 491.64L51.39 137.7L140.61 137.7L140.61 161.94L74.67 161.94C74.67 345.21 74.67 447.03 74.67 467.39C240.48 467.39 380.12 467.39 564.36 467.39C564.36 447.03 564.36 345.21 564.36 161.94L499.39 161.94L499.39 137.7L588.61 137.7L588.61 491.64L51.39 491.64Z",
    id: "a2g10ISnRo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91 590.55C2.91 616.73 24.24 637.09 49.45 637.09C103.66 637.09 537.31 637.09 591.52 637.09C617.7 637.09 638.06 615.76 638.06 590.55C638.06 583.76 638.06 529.45 638.06 522.67C498.42 522.67 515.88 522.67 2.91 522.67C2.91 536.24 2.91 583.76 2.91 590.55ZM379.15 570.18L261.82 570.18L274.42 537.21L366.55 537.21L379.15 570.18ZM623.52 590.55C623.52 608 608.97 622.55 591.52 622.55C537.31 622.55 103.66 622.55 49.45 622.55C32 622.55 17.45 608 17.45 590.55C17.45 586.99 17.45 569.21 17.45 537.21L258.91 537.21L241.45 584.73L400.48 584.73L383.03 537.21L624.48 537.21L624.48 590.55C623.97 590.55 623.64 590.55 623.52 590.55Z",
    id: "a1iqGK4OyT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45 186.18L209.45 239.52L359.76 239.52L359.76 288L433.45 213.33L359.76 138.67L359.76 186.18L209.45 186.18ZM412.12 212.36L374.3 251.15L374.3 224L224 224L224 199.76L374.3 199.76L374.3 173.58L412.12 212.36Z",
    id: "f11iRxOZkq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.55 325.82L280.24 400.48L280.24 352L430.55 352L430.55 298.67L280.24 298.67L280.24 251.15L206.55 325.82ZM416 314.18L416 338.42L265.7 338.42L265.7 365.58L227.88 326.79L265.7 288L265.7 315.15L416 315.15L416 314.18Z",
    id: "aaEStTk34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.48 49.45C464.48 37.82 454.79 28.12 443.15 28.12C431.52 28.12 421.82 37.82 421.82 49.45C421.82 61.09 431.52 70.79 443.15 70.79C454.79 70.79 464.48 61.09 464.48 49.45ZM449.94 49.45C449.94 53.33 447.03 56.24 443.15 56.24C439.27 56.24 436.36 53.33 436.36 49.45C436.36 45.58 439.27 42.67 443.15 42.67C447.03 42.67 449.94 45.58 449.94 49.45Z",
    id: "f2GclBDA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36 49.45C404.36 37.82 394.67 28.12 383.03 28.12C371.39 28.12 361.7 37.82 361.7 49.45C361.7 61.09 371.39 70.79 383.03 70.79C394.67 70.79 404.36 61.09 404.36 49.45ZM389.82 49.45C389.82 53.33 386.91 56.24 383.03 56.24C379.15 56.24 376.24 53.33 376.24 49.45C376.24 45.58 379.15 42.67 383.03 42.67C386.91 42.67 389.82 45.58 389.82 49.45Z",
    id: "arcgKlNAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.24 49.45C344.24 37.82 334.55 28.12 322.91 28.12C311.27 28.12 301.58 37.82 301.58 49.45C301.58 61.09 310.3 70.79 322.91 70.79C334.55 70.79 344.24 61.09 344.24 49.45ZM329.7 49.45C329.7 53.33 326.79 56.24 322.91 56.24C319.03 56.24 316.12 53.33 316.12 49.45C316.12 45.58 319.03 42.67 322.91 42.67C326.79 42.67 329.7 45.58 329.7 49.45Z",
    id: "fBp7BVUvU"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2g10ISnRo",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2g10ISnRo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iqGK4OyT",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1iqGK4OyT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f11iRxOZkq",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f11iRxOZkq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aaEStTk34",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aaEStTk34",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2GclBDA1",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2GclBDA1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arcgKlNAA",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arcgKlNAA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fBp7BVUvU",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fBp7BVUvU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDomain1);
export default __webpack_public_path__ + "static/media/switch-domain-1.2b8170be7757f7f074e3158ff625fca7.svg";
export { ForwardRef as ReactComponent };